import { TTransactionFilter } from '../data/transactionTypes';

export const generateTransactionTypeId = (data: TTransactionFilter) =>
  `${data.transactionType}-${data.type?.toString()?.toLowerCase() ?? null}`;
